<div class="apmt-status-wrap">
  <div class="middle">
    <div class="tbl">
      <div>
        <span class="txt">시작</span>
        <span class="date">{{start}}</span>
      </div>
      <div>
        <span class="txt">종료</span>
        <span class="date">{{end}}</span>
      </div>
    </div>
    <div class="btn-progress"
      [ngClass]="{disabled: isNotInProgress}"
      type="button">{{status}}</div>
    <a [href]="link" class="btn-link">
      <button mat-icon-button class="btn-connect">
        <mat-icon class="icon">call</mat-icon>
        <span>센터연결</span>
      </button>
    </a>
  </div>
</div>
